import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

interface CalculationsUnavailable {
  allUnavailable?: boolean;
}

export const CardWrapper = styled.div`
  > div.OfferComparisonCard {
    max-width: -webkit-fill-available;
  }

  @media (max-width: ${Breakpoints.b560}px) {
    .offerComparisonCard-terms-accordion {
      font-size: smaller;
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
`;

export const VehicleUnavailable = styled.div`
    background-color: #EDF2F7;
    width: 100%;
    border-radius:24px;
`

export const VehicleWrap = styled.div`
    position:relative;

    > img {
        display: block;
        height: auto;
        width:100%;
        object-fit: contain;
    }
    > div {
       position: absolute;
       top: 50%;
       left: 50%;
       transform: translate(-50%, -50%);
       width:90%;
       text-align:center; 
    }
`

export const FinanceCalculationsUnavailableWrap = styled.div<CalculationsUnavailable>(
  ({allUnavailable}) => `
  @media screen and (min-width: 960px) {
    > div {
      padding-top: 88px;
      height: ${allUnavailable ? '100%' : 'calc(100% - 125px)'}
    }
  }
`);